import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import AdminNavbar from './AdminNavbar';
import Footer from './Footer';
import './AdminRoute.css';

const AdminRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('token') !== null;

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <AdminNavbar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          transition: theme => theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
          position: 'relative',
          minHeight: '100vh',
        }}
      >
        <Box>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default AdminRoute;
